import img1 from './image1.png';
import img2 from './image2.png';
import img3 from './image3.png';
import img4 from './image4.png';
import img5 from './image5.png';
import img6 from './image6.png';
import img7 from './image7.png';
import img8 from './image8.png';
import img9 from './image9.png';
import img10 from './image10.png';
import img11 from './image11.png';
import img12 from './image12.png';
import img13 from './image13.png';
import img14 from './image14.png';
import img15 from './image15.png';
import img16 from './image16.png';
import img17 from './image17.png';
import img18 from './image18.png';

const images = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18
};

export default images;
